<template>
    <div class="instruction" ref="secondApply">
        <!--<a href="javascript:;" class="close" v-if="stage === 'first'">-->
            <!--<img src="@/assets/images/close.png" @click="closeDialog" alt="">-->
        <!--</a>-->
        <div v-if="stage === 'first'">
            <div class="item">
                <img src="http://source.weicistudy.com/draw/1@3x.png"/>
            </div>
            <div class="item">
                <img src="http://source.weicistudy.com/draw/2@3x.png"/>
            </div>
        </div>
        <div v-else>
            <div class="item">
                <img src="http://source.weicistudy.com/draw/second-1.png"/>
            </div>
            <div class="item">
                <img src="http://source.weicistudy.com/draw/second-2.png"/>
            </div>
            <div class="item second-3">
                <img class="top-img" style="z-index: 3" src="http://source.weicistudy.com/draw/second-link.png" alt="">
                <!--<winner-list></winner-list>-->
                <winner-list v-if="isHasData && oneList.length" :winnerList="oneList"></winner-list>
                <img class="bottom-img" style="z-index: 3;" src="http://source.weicistudy.com/draw/second-link.png" alt="">
            </div>
            <div class="item second-4">
                <img src="http://source.weicistudy.com/draw/second-4.png"/>
            </div>
            <div class="item">
                <img src="http://source.weicistudy.com/draw/second-5.png"/>
            </div>
            <div class="item">
                <img src="http://source.weicistudy.com/draw/second-6.png"/>
            </div>
            <div class="item">
                <img src="http://source.weicistudy.com/draw/second-7.png"/>
            </div>
        </div>
        <div class="btn-area" style="z-index: 22">
            <a href="javascript:;" class="btn"
               :class="{default: (status === 3 && signUp === 0) || (status === 4 && signUp === 0) || (status === 5 && signUp === 0) , success: (status === 3 && signUp === 1) || (status === 4 && signUp === 1) || (status === 5 && signUp === 1)}"
               @click="clickHandle"
               :style="{backgroundImage: 'url(' + btnImg + ')'}">
                {{btnText}}
            </a>
        </div>
        <alert style="z-index: 88" :show.sync="show" :alert-type="alertType" stage="second" @application="pushSucessPage"></alert>
        <broken-net :show.sync="noNet" :content="showText"></broken-net>
    </div>
</template>

<script>
    import Alert from "@/components/lottery/Alert";
    import LotteryService from '@/service/LotteryService'
    import WinnerList from '@/components/lottery/WinnerList'
    import BrokenNet from "@/components/lottery/BrokenNet";
    export default {
        name: "SecondApply",
        components: {Alert, WinnerList, BrokenNet},
        data () {
            return {
                show: false,
                alertType: 'fail',
                baseUrl: process.env.BASE_URL,
                btnImg: '',
                btnText: '',
                status: 0,
                signUp: 0,
                activityBatch: 0,
                userCode: '',
                session: '',
                appId: 0,
                bannerId: 0,
                leaveDay: 0,
                stage: 'first', // first:第一阶段抽奖时的报名;second:第二阶段新报名
                oneList: [], // 第一轮获奖名单
                isHasData: false, // 是否拿到获奖名单数据
                noNet: false,
                showText: '网络无效，请重试！',
                clickFlag: true // 是否连续两次点击标志
            }
        },
        created () {
            this.userCode = this.$route.query.user_code
            this.session = this.$route.query.session
            this.appId = this.$route.query.app_id
            this.bannerId = this.$route.query.banner_id
            this.stage = this.$route.query.stage
            // console.log(1)
            this.init()
            this.initWinnerList()
            var el = document.body;
            let _this = this
            _this.showText = '网络无效，请重试！'
            if (el.addEventListener) {
                // window.addEventListener("online", function () {
                //     alert("online");}, true);
                window.addEventListener("offline", function () {
                    _this.noNet = true;
                    }, true);
            } else if (el.attachEvent) {
                // window.attachEvent("ononline", function () {
                //     alert("online");});
                window.attachEvent("onoffline", function () {
                    _this.noNet = true;
                });
            } else {
                // window.ononline = function () {
                //     alert("online");};
                window.onoffline = function () {
                    _this.noNet = true;
                };
            }
        },
        // mounted () {
        //    this.$refs.secondApply.scrollTop = 0
        // },
        methods: {
            init () {
                let _this = this;
                LotteryService.getInfo(this.userCode,this.session,this.appId,this.bannerId)
                    .then(res => {
                        if (res.data.result_code === 200) {
                            _this.status = res.data.info.activity_status;
                            _this.signUp = res.data.info.sign_up
                            _this.activityBatch = res.data.info.activity_batch
                            // console.log(res)
                            // if (_this.status === (3 || 4 || 5) && _this. signUp === 0) {
                            //     _this.btnText = '立即报名'
                            //     _this.btnImg = _this.baseUrl + 'images/apply.png'
                            // } else if (_this.status === (3 || 4 || 5) && _this. signUp === 1) {
                            //     _this.btnText = '报名成功'
                            //     _this.btnImg = _this.baseUrl + 'images/success.png'
                            // }
                            if ((_this.status === 3 && _this. signUp === 0) || (_this.status === 4 && _this. signUp === 0) || (_this.status === 5 && _this. signUp === 0)) {
                                _this.btnText = '立即报名'
                                // _this.btnImg = _this.baseUrl + 'images/apply.png'
                                _this.btnImg = 'http://source.weicistudy.com/draw/public/apply.png'
                            } else if ((_this.status === 3 && _this. signUp === 1) || (_this.status === 4 && _this. signUp === 1) || (_this.status === 5 && _this. signUp === 1)) {
                                _this.btnText = '报名成功'
                                // _this.btnImg = _this.baseUrl + 'images/success.png'
                                _this.btnImg = 'http://source.weicistudy.com/draw/public/success.png'
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            initWinnerList () {
                let _this = this
                LotteryService.list(_this.userCode, _this.session, _this.appId, _this.bannerId)
                    .then(res => {
                        console.log(res)
                        if (res.data.result_code === 200) {
                            _this.oneList = res.data.one_list
                            _this.isHasData = true
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }, // 获取获奖名单
            clickHandle () {
                let _this = this
                
                if (_this.clickFlag) {
                    _this.clickFlag = false
                    if ((_this.status === 3 && _this. signUp === 0) || (_this.status === 4 && _this. signUp === 0) || (_this.status === 5 && _this. signUp === 0)) {
                    if (!window.navigator.onLine) {
                        this.noNet = true
                        _this.clickFlag = true
                    } else {
                        LotteryService.apply(this.userCode, this.session, this.appId, this.bannerId)
                            .then(res => {
                                if (res.data.result_code === 200) {
                                    this.show = true
                                    this.alertType = 'success'
                                    this.btnText = '报名成功'
                                    // this.btnImg = this.baseUrl + 'images/success.png'
                                    this.btnImg = 'http://source.weicistudy.com/draw/public/success.png'
                                    this.signUp = 1
                                    this.activityBatch = 2
                                } else if (res.data.result_code === 1001) {
                                    this.show = true
                                    this.alertType = 'uncomplete'
                                    
                                } else if (res.data.result_code === 1002) {
                                    this.show = true
                                    this.alertType = 'fail'
                                    
                                } else {
                                    // alert('操作失败，请稍后重试！')
                                    _this.showText = '报名失败！';
                                    _this.noNet = true;
                                    
                                }
                               
                            })
                            .catch(error => {
                                console.log(error)
                                // alert('网络异常，请稍后重试！')
                                _this.showText = '操作失败，请稍后重试！';
                                _this.noNet = true;
                               
                            })
                            .finally(() => {
                                _this.clickFlag = true
                            })
                    }
                }
                }

            },
            closeDialog () {
                // if (this.signUp === 1) {
                //     this.$router.push({
                //         path: '/lottery/detail',
                //         query: {
                //             stage: 'second',
                //             sortType: 'success'
                //         }
                //     })
                // } else {
                //     this.$router.go(-1)
                // }
                this.$router.go(-1)
            },
            pushSucessPage () {
                if (this.stage === 'first') {
                    this.$router.push({
                        path: '/lottery/detail',
                        query: {
                            stage: 'second',
                            sortType: 'success',
                            user_code: this.userCode,
                            session: this.session,
                            app_id: this.appId,
                            banner_id: this.bannerId
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .instruction {
        /*width: 100%;*/
        background-color: #FD7759;
    }
    .instruction .item {
        width: 100%;
        padding: 0;
        margin: 0;
    }
    .instruction  .second-3 {
        margin-top: 24px;
        position: relative;
    }
    .instruction .item img {
        width: 100%;
        display: block;
    }
    .instruction  .second-3 img {
        width: 510px;
        position: absolute;
        left:120px;
    }
    .instruction  .second-3 .top-img{
        top:-52px;
    }
    .instruction  .second-3 .bottom-img{
        bottom:-52px;
    }
    .instruction  .second-4 {
        margin-top: -7px;
    }
    .instruction .btn-area {
        width: 100%;
        position: fixed;
        display: block;
        bottom: 0;
        left: 0;
        padding: 25px 65px;
        text-align: center;
        box-sizing: border-box;
        z-index: 2000;
    }

    .instruction .btn-area .btn {
        display: block;
        height: 150px;
        /*background-image: url('../../assets/images/success.png');*/
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-origin: border-box;
        background-position: left top;

        padding-top: 38px;
        box-sizing: border-box;
        font-size: 36px;
    }

    .success {
        color: #F6EAE5;
        text-shadow: 3px 3px 9px #b89888;
    }

    .unbegin {
        color: #833600;
        text-shadow: 3px 3px 9px #EFA832;
    }

    .default {
        color: #FFFFFF;
        text-shadow: 3px 3px 9px #D4652E;
    }
    .close {
        position: absolute;
        right:20px;
        top: 20px;
        width: 72px;
    }
    .close img {
        width: 100%;
    }
</style>